import { FilterAutocomplete } from '../baseInputTypes/FilterAutocomplete'

export const Applications = () => (
  <FilterAutocomplete
    label="Applications"
    fieldName={'applications'}
    fieldPath={'productInformation.applications'}
  />
)
